// import * as React from "react";
// import { Button, ButtonProps, Link, styled, Typography } from "@mui/material";
// import "../css/login.css";
// import login from "../assests/login-logo.png";
// import { LoadingButton } from "@mui/lab";

// const LoadingLoginButton = styled(LoadingButton)<ButtonProps>(() => ({
//    color: "var(--buttonText)",
//    backgroundColor: "var(--secondary)",
//    "&:hover": {
//       backgroundColor: "var(--buttonHover)",
//    },
// }));

// const Temp = () => {
//    return (
//       // <div className="content"
//       //    style={{
//       //       backgroundColor: "white",
//       //       display: "flex",
//       //       flex: 1,
//       //       flexDirection: "row",
//       //       height: "100%",
//       //       overflow: "hidden",
//       //    }}
//       // >
//       //    <div className="left-content"
//       //       style={{
//       //          display: "flex",
//       //          //    flex: 1,
//       //          width: "52%",
//       //          backgroundColor: "#161616",
//       //       }}
//       //    >
//       //       <Typography className="login-text">Login</Typography>
//       //       <div className="login-input">
//       //          <input className="search-box" placeholder="Id" />
//       //       </div>
//       //       <div className="login-password">
//       //          <input
//       //             type={"password"}
//       //             className="search-box"
//       //             placeholder="Password"
//       //          />
//       //       </div>
//       //       {/* <div className="forgot-password">
//       //           <Link href="#">
//       //             Forgot password?
//       //           </Link>
//       //         </div> */}
//       //       <div className="button">
//       //          <LoadingLoginButton
//       //             variant="contained"
//       //             loading={false}
//       //             className="login-btn"
//       //          >
//       //             <Typography className="submit">Submit</Typography>
//       //          </LoadingLoginButton>
//       //       </div>
//       //       {/* <span style={{ color: "white" }}>left content</span> */}

//       //    </div>
//       //    <svg
//       //       width="58"
//       //       height="100%"
//       //       viewBox="0 0 58 720"
//       //       fill="none"
//       //       xmlns="http://www.w3.org/2000/svg"
//       //       style={{ position: "relative", left: "-1px" }}
//       //    >
//       //       <path
//       //          d="M0 720V0C13.5 42 58 183.5 58 365C58 541.502 17.3333 672.5 0 720Z"
//       //          fill="#161616"
//       //       />
//       //    </svg>

//       //    <div className="logo" style={{ display: "flex", flex: 1 }}>
//       //       <img src={login} className="loginScreen-image" />
//       //    </div>
//       // </div>
//    );
// };

// export default Temp;

import React, { useEffect } from "react";
import {
   Document,
   Page,
   Text,
   View,
   StyleSheet,
   PDFViewer,
   Font,
   Image,
} from "@react-pdf/renderer";

// Create styles

// Font.register({
//   family: 'Nunito',
//   src: `https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0e.ttf`,
// });

const App = ({ selectedNodes }: any) => {
   selectedNodes = [{ data: { label: "1", desc: "desc" } }];
   return (
      <PDFViewer style={styles.viewer}>
         {/* Start of the document*/}
         <Document>
            {/*render a single page*/}
            <Page size="A4" style={styles.page}>
               <View style={styles.header}>
                  <Image
                     source={require("../assests/login-logo.png")}
                     style={{ height: 30, marginRight: 10 }}
                  />
                  <Text
                     style={{
                        color: "black",
                        fontSize: 20,
                        fontWeight: "bold",
                     }}
                  >
                     MediFlow
                  </Text>
               </View>
               <View
                  style={{
                     marginTop: 30,
                  }}
               >
                  <Text
                     style={{
                        fontSize: 14,
                        color: "#449183",
                     }}
                  >
                     Patient's Info
                  </Text>
                  <Text
                     style={{
                        fontSize: 12,
                        marginTop: 10,
                        color: "#161616",
                        marginLeft: 10,
                     }}
                  >
                     Name: Neelkanth Tandel
                  </Text>
                  <Text
                     style={{
                        fontSize: 12,
                        marginTop: 5,
                        color: "#161616",
                        marginLeft: 10,
                     }}
                  >
                     Age: 20
                  </Text>
               </View>
               <View
                  style={{
                     marginTop: 30,
                  }}
               >
                  <Text
                     style={{
                        fontSize: 14,
                        color: "#449183",
                     }}
                  >
                     Summary
                  </Text>
                  <View style={{ paddingHorizontal: 10 }}>
                     {selectedNodes.map((data: any, index: number) => (
                        <View key={index}>
                           <View
                              style={{
                                 display: "flex",
                                 flexDirection: "row",
                                 marginTop: 20,
                                 justifyContent: "space-between",
                                 paddingRight: 7,
                              }}
                              //  onClick={() => {
                              //     //   setExpanded(
                              //     //      expanded === data.id ? false : data.id
                              //     //   );
                              //  }}
                           >
                              <View
                                 style={{
                                    backgroundColor: "#449183",
                                    borderRadius: "50%",
                                    width: 10,
                                    height: 10,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 3,
                                 }}
                              ></View>
                              <View
                                 style={{
                                    display: "flex",
                                    flex: 1,
                                    marginLeft: "10px",
                                    flexDirection: "column",
                                 }}
                              >
                                 {data.data.label
                                    .split("\\n")
                                    .map((ele: string, index: any) => (
                                       <Text
                                          style={{
                                             fontSize: 14,
                                             //  fontWeight: "600",
                                             lineHeight: 18,
                                             color: "#161616",
                                          }}
                                          key={index}
                                       >
                                          {ele}
                                       </Text>
                                    ))}
                              </View>
                           </View>
                           {/* {expanded === data.id ? ( */}
                           {/* <View className="description-container">
                              <Text className="description">
                                 {data.data.description}
                              </Text>
                           </View> */}
                           {/* ) : null} */}
                        </View>
                     ))}
                  </View>
               </View>
            </Page>
         </Document>
      </PDFViewer>
   );
};
const styles = StyleSheet.create({
   page: {
      backgroundColor: "#fff",
      color: "white",
      paddingHorizontal: 20,
   },
   viewer: {
      width: window.innerWidth, //the pdf viewer will take up all of the width and height
      height: window.innerHeight,
   },
   header: {
      marginTop: 20,
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
   },
});
export default App;
